import { render, staticRenderFns } from "./IcoPersonCircle.vue?vue&type=template&id=61d54bd1"
import script from "./IcoPersonCircle.vue?vue&type=script&lang=js"
export * from "./IcoPersonCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports